export const COOKIE_ACCEPT = 'cookie:accept'
export const COOKIE_DECLINE = 'cookie:decline'
